import React from 'react';
import { FaAward, FaCheck, FaUserTie } from 'react-icons/fa';

export const InvitationBanner = ({ invitationInfo }) => (
  <div className="bg-green-500/20 border border-green-400/30 rounded-xl p-4 mb-6">
    <div className="flex items-start space-x-3">
      <div className="w-10 h-10 bg-green-500/30 rounded-full flex items-center justify-center flex-shrink-0">
        <span className="text-xl">🎉</span>
      </div>
      <div>
        <h3 className="text-green-300 font-medium">You've Been Invited!</h3>
        <p className="text-green-200/80 text-sm mt-1">
          {invitationInfo.invitation.invited_by_user_name} from their family has invited you to join Legacy Forge Family as a trusted professional.
        </p>
        {invitationInfo.profile?.recommendation_note && (
          <p className="text-green-200/60 text-sm mt-2 italic">
            "{invitationInfo.profile.recommendation_note}"
          </p>
        )}
      </div>
    </div>
  </div>
);

export const UserInviteBanner = ({ userInviteInfo }) => (
  <div className="bg-blue-500/20 border border-blue-400/30 rounded-xl p-4 mb-6">
    <div className="flex items-start space-x-3">
      <div className="w-10 h-10 bg-blue-500/30 rounded-full flex items-center justify-center flex-shrink-0">
        <span className="text-xl">👋</span>
      </div>
      <div>
        <h3 className="text-blue-300 font-medium">Personal Invitation from {userInviteInfo.inviter_name}</h3>
        <p className="text-blue-200/80 text-sm mt-1">
          {userInviteInfo.inviter_name}, a Legacy Forge member, personally invited you to join our Professional Partner Network.
        </p>
        {userInviteInfo.city && (
          <p className="text-blue-200/60 text-sm mt-1">
            Serving families in {userInviteInfo.city}{userInviteInfo.region ? `, ${userInviteInfo.region}` : ''}
          </p>
        )}
      </div>
    </div>
  </div>
);

export const FoundingAdvisorPromo = () => (
  <div className="bg-gradient-to-r from-amber-500/20 to-amber-600/20 border border-amber-400/30 rounded-xl p-5 mb-6" data-testid="founding-advisor-promo">
    <div className="flex items-start space-x-4">
      <div className="w-12 h-12 bg-amber-500/30 rounded-full flex items-center justify-center flex-shrink-0">
        <FaAward className="text-amber-400 text-xl" />
      </div>
      <div>
        <h3 className="text-amber-300 font-bold text-lg">Become a Founding Advisor</h3>
        <p className="text-amber-200/80 text-sm mt-1">
          Join during our launch and receive exclusive perks:
        </p>
        <ul className="text-amber-200/70 text-sm mt-2 space-y-1">
          <li className="flex items-center gap-2"><FaCheck className="text-amber-400 text-xs" /> Permanent "Founding Advisor" badge on your profile</li>
          <li className="flex items-center gap-2"><FaCheck className="text-amber-400 text-xs" /> Featured listing in the professional directory</li>
          <li className="flex items-center gap-2"><FaCheck className="text-amber-400 text-xs" /> Priority visibility to families seeking advisors</li>
        </ul>
        <p className="text-amber-300/60 text-xs mt-2 italic">Limited to early launch partners only</p>
      </div>
    </div>
  </div>
);

export const ReferrerBanner = ({ referrerInfo }) => (
  <div className="mb-6 p-4 bg-emerald-50 border border-emerald-200 rounded-lg">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
        <FaUserTie className="text-emerald-600" />
      </div>
      <div>
        <p className="text-emerald-800 font-medium">
          Referred by {referrerInfo.referrer_name}
        </p>
        <p className="text-emerald-600 text-sm">
          You were invited by a trusted colleague in our network
        </p>
      </div>
    </div>
  </div>
);
